import React, { useContext } from "react";
import cn from "classnames";
import { NavLink } from "react-router-dom";
import { FilterContext } from "../FilterContextProvider";
import Logout from "../Auth/Logout";
import { UserContext } from "../Auth/UserContextProvider";
import Button from "../Components/Button";
import { ManualOfflineContext } from "./ManualOfflineContext";
import { OnlineStatusContext } from "./OnlineStatusContext";

const SalesLayout = ({ children }) => {
  const chosen = "pt-4 pl-8 pr-4 text-blue-500 font-bold";
  const notChosen = "pt-4 pl-8 pr-4 hover:text-blue-500";
  const { filterData } = useContext(FilterContext);
  const { isAdmin } = useContext(UserContext);
  const { isManager } = useContext(UserContext);
  const { manualOffline, setManualOffline } = useContext(ManualOfflineContext);
  const { isOnline } = useContext(OnlineStatusContext);

  return (
    <div className="text-black ml-24 h-14 border-b bg-white">
      <div className="flex justify-between">
        <div className="flex flex-row w-full mb-4 text-sm text-black h-14">
          {filterData.artist_name && (
            <div className="bg-blue-500 text-white h-14 flex p-4 font-semibold">{filterData.artist_name}</div>
          )}
          <NavLink to="/sales/events" activeClassName={chosen} className={notChosen}>
            <p>Events</p>
          </NavLink>
          <NavLink to="/sales/websales/" activeClassName={chosen} className={notChosen}>
            <p>Web Sales</p>
          </NavLink>
          <NavLink to="/sales/comps" activeClassName={chosen} className={notChosen}>
            <p>Comps</p>
          </NavLink>
          {(isAdmin || isManager) && (
            <NavLink to="/sales/eventcomparison" activeClassName={chosen} className={notChosen}>
              <p>Event Comparison</p>
            </NavLink>
          )}
          <div className="flex-grow flex flex-row justify-end items-center pr-24">
            {isOnline ? (
              <Button
                className={cn("button button-auto", { "button-warning": manualOffline })}
                onClick={() => setManualOffline(!manualOffline)}
                text={manualOffline ? "Offline mode ON" : "Go offline"}
              ></Button>
            ) : (
              <Button className="button button-auto button-warning" onClick={() => {}} text="Offline" disabled></Button>
            )}
          </div>
          <Logout></Logout>
        </div>
      </div>
      <div className="bg-gray-100 -mt-4 pt-4">{children}</div>
    </div>
  );
};

export default SalesLayout;
